/* eslint-disable react/no-unescaped-entities */
/* eslint-disable prefer-const */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-restricted-syntax */
import React from 'react';
import i18n from '@utils/i18n';

import { Stack, Typography } from '@mui/material';
import useResponsive from '@hooks/useResponsive';
import env from '@constants/env';

const Bg = `${env.s3BaseUrl}/landing-page/homepage/banner-timeline.png`;
const BgTablet = `${env.s3BaseUrl}/landing-page/homepage/timeline-tb.png`;

const milestoneStyle = {
  fontSize: { xs: '14px', sm: '18px' },
  color: '#FFF',
  fontWeight: 500,

  whiteSpace: 'pre-line',
  lineHeight: '130%',
  letterSpacing: { xs: '-0.7px', sm: '-0.9px' },
  wordBreak: 'keep-all', // Prevent breaking words
  overflowWrap: 'break-word'
};

const yearStyle = {
  fontSize: { xs: '20px', sm: 24 },
  color: '#FFF',
  fontWeight: 500,
  lineHeight: '100%',
  letterSpacing: { xs: '-1px', sm: '-1.2px' }
};

const TimelineMobile = () => {
  const t = i18n.getFixedT(null, null, 'pages.flagshop.timeline');

  const isTablet = useResponsive('between', 0, 600, 1199);

  return (
    <Stack
      sx={{
        display: 'flex',
        py: { xs: '60px', sm: '140px' },
        alignItems: 'center',
        minHeight: '100svh',
        position: 'relative'
      }}
    >
      {/* Background with parallax effect */}
      <img
        src={isTablet ? BgTablet : Bg}
        alt="banner"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          zIndex: 0
        }}
      />

      {/* Horizontally moving timeline section */}
      <div
        style={{
          width: '100%',
          position: 'relative'
        }}
      >
        <Stack
          sx={{
            width: '100%',
            height: '100%',

            px: { xs: '20px', sm: '40px' },

            flexDirection: 'column',
            position: 'relative',
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
            gap: 5
          }}
        >
          <Stack textAlign="left" gap={3}>
            <Typography
              sx={{
                fontSize: '32px',
                color: '#FFF',
                fontFamily: 'Swear Display',
                fontWeight: 500,
                fontStyle: 'italic',
                lineHeight: '100%',
                letterSpacing: '-1.6px'
              }}
            >
              History
            </Typography>
            <Stack sx={{ gap: 5 }}>
              <Stack gap={0.5}>
                <Typography
                  fontWeight={700}
                  fontFamily="Pretendard"
                  sx={{
                    color: '#FFF',
                    fontSize: { xs: 30, sm: 50 },
                    letterSpacing: { xs: '-1.5px', sm: '-2.5px' },
                    lineHeight: '130%',
                    whiteSpace: 'pre-line'
                  }}
                >
                  {t('title-mobile')}
                </Typography>
              </Stack>
              <Typography
                fontWeight={500}
                fontFamily="Pretendard"
                sx={{
                  color: '#FFF',
                  fontSize: { xs: 18, sm: 24 },
                  letterSpacing: { xs: '-0.9px', sm: '-1.2px' },
                  opacity: 0.8,
                  lineHeight: '100%',
                  whiteSpace: 'pre-line'
                }}
              >
                {t('subtitle')}
              </Typography>
            </Stack>
          </Stack>
          {/* timeline years */}
          <Stack
            sx={{
              flexDirection: 'column',

              position: 'relative'
            }}
          >
            {/* 2025 */}
            <Stack>
              {/* year */}
              <Stack
                sx={{
                  justifyContent: 'center',
                  borderBottom: '0px solid #FFFFFF',
                  position: 'relative'
                }}
              >
                <Typography sx={yearStyle}>2025</Typography>
              </Stack>
              {/* milestones */}
              <Stack
                sx={{
                  mt: '20px',
                  gap: { xs: '9px', sm: '20px' }
                }}
              >
                <Typography sx={milestoneStyle}>
                  {t('2025.2.content')}
                </Typography>
                <Typography sx={milestoneStyle}>
                  {t('2025.1.content')}
                </Typography>
              </Stack>
            </Stack>
            {/* 2024 */}
            <Stack sx={{ mt: '60px' }}>
              {/* year */}
              <Stack
                sx={{
                  justifyContent: 'center',
                  position: 'relative',
                  borderBottom: '0px solid #FFFFFF'
                }}
              >
                <Typography sx={yearStyle}>2024</Typography>
              </Stack>
              {/* milestones */}
              <Stack
                sx={{
                  mt: '20px',
                  gap: { xs: '9px', sm: '20px' }
                }}
              >
                <Typography sx={milestoneStyle}>
                  {t('2024.10.content')}
                </Typography>
                <Typography sx={milestoneStyle}>
                  {t('2024.9.content')}
                </Typography>
                <Typography sx={milestoneStyle}>
                  {t('2024.8.content')}
                </Typography>
                <Typography sx={milestoneStyle}>
                  {t('2024.7.content')}
                </Typography>
                <Typography sx={milestoneStyle}>
                  {t('2024.6.content')}
                </Typography>
                <Typography sx={milestoneStyle}>
                  {t('2024.5.content')}
                </Typography>
                <Typography sx={milestoneStyle}>
                  {t('2024.4.content')}
                </Typography>
                <Typography sx={milestoneStyle}>
                  {t('2024.3.content')}
                </Typography>
                <Typography sx={milestoneStyle}>
                  {t('2024.2.content')}
                </Typography>
                <Typography sx={milestoneStyle}>
                  {t('2024.1.content')}
                </Typography>
              </Stack>
            </Stack>
            {/* 2023 */}
            <Stack sx={{ mt: '60px' }}>
              {/* year */}
              <Stack
                sx={{
                  borderBottom: '0px solid #FFFFFF',
                  justifyContent: 'center',
                  position: 'relative'
                }}
              >
                <Typography sx={yearStyle}>2023</Typography>
              </Stack>
              {/* milestones */}
              <Stack
                sx={{
                  mt: '20px',
                  gap: { xs: '9px', sm: '20px' }
                }}
              >
                <Typography sx={milestoneStyle}>
                  {t('2023.6.content')}
                </Typography>
                <Typography sx={milestoneStyle}>
                  {t('2023.5.content')}
                </Typography>
                <Typography sx={milestoneStyle}>
                  {t('2023.4.content')}
                </Typography>
                <Typography sx={milestoneStyle}>
                  {t('2023.3.content')}
                </Typography>
                <Typography sx={milestoneStyle}>
                  {t('2023.2.content')}
                </Typography>
                <Typography sx={milestoneStyle}>
                  {t('2023.1.content')}
                </Typography>
              </Stack>
            </Stack>
            {/* 2022 */}
            <Stack sx={{ mt: '60px' }}>
              {/* year */}
              <Stack
                sx={{
                  borderBottom: '0px solid #FFFFFF',
                  justifyContent: 'center',
                  position: 'relative'
                }}
              >
                <Typography sx={yearStyle}>2022</Typography>
              </Stack>
              {/* milestones */}
              <Stack
                sx={{
                  mt: '20px',
                  gap: { xs: '9px', sm: '20px' }
                }}
              >
                <Typography sx={milestoneStyle}>
                  {t('2022.3.content')}
                </Typography>
                <Typography sx={milestoneStyle}>
                  {t('2022.2.content')}
                </Typography>
                <Typography sx={milestoneStyle}>
                  {t('2022.1.content')}
                </Typography>
              </Stack>
            </Stack>
            {/* 2021 */}
            <Stack sx={{ width: 'auto', mt: '60px' }}>
              {/* year */}
              <Stack
                sx={{
                  position: 'relative',
                  borderBottom: '0px solid #FFFFFF',
                  justifyContent: 'center'
                }}
              >
                <Typography sx={yearStyle}>2021</Typography>
              </Stack>
              {/* milestones */}
              <Stack
                sx={{
                  mt: '20px',
                  gap: { xs: '9px', sm: '20px' }
                }}
              >
                <Typography sx={milestoneStyle}>
                  {t('2021.8.content')}
                </Typography>
                <Typography sx={milestoneStyle}>
                  {t('2021.7.content')}
                </Typography>
                <Typography sx={milestoneStyle}>
                  {t('2021.6.content')}
                </Typography>
                <Typography sx={milestoneStyle}>
                  {t('2021.5.content')}
                </Typography>
                <Typography sx={milestoneStyle}>
                  {t('2021.4.content')}
                </Typography>
                <Typography sx={milestoneStyle}>
                  {t('2021.3.content')}
                </Typography>
                <Typography sx={milestoneStyle}>
                  {t('2021.2.content')}
                </Typography>
                <Typography sx={milestoneStyle}>
                  {t('2021.1.content')}
                </Typography>
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </div>
    </Stack>
  );
};

export default TimelineMobile;
